import { Injectable } from "@angular/core";
import { DownloadCsv } from "@models/download-csv.model";
import BaseService from "./base.service";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

@Injectable({
  providedIn: "root",
})
export class DownloadCsvServiceService extends BaseService<DownloadCsv> {
  public exportExcelFile(excelContent: any[], excelFileName: string): void {
    const worksheetProject: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelContent, {
      skipHeader: true,
    });

    const workbook: XLSX.WorkBook = {
      Sheets: {
        "Project Details": worksheetProject,
      },
      SheetNames: ["Project Details"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, `${fileName}_${new Date().getTime()}${EXCEL_EXTENSION}`);
  }
}
